import TimeLineDataInterface from "../interface/timeline";

const formation: TimeLineDataInterface[] = [
  {
    date: "eductionTimeline0Date",
    title: "eductionTimeline0Title",
    subTitle: "eductionTimeline0SubTitle",
  },
  {
    date: "eductionTimeline1Date",
    title: "eductionTimeline1Title",
    subTitle: "eductionTimeline1SubTitle",
  },
  {
    date: "eductionTimeline2Date",
    title: "eductionTimeline2Title",
    subTitle: "eductionTimeline2SubTitle",
  },
];

export default formation;
